// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__qBClX"};